import BaseCardBehavior from 'State/Card/CardBehavior/BaseCardBehavior';
import BoomCardBehavior from 'State/Card/CardBehavior/BoomCardBehavior';
import CanisterPreBoosterCardBehavior from 'State/Card/CardBehavior/CanisterPreBoosterCardBehavior';
import GoldCardBehavior from 'State/Card/CardBehavior/GoldCardBehavior';
import JokerCardBehavior from 'State/Card/CardBehavior/JokerCardBehavior';
import JokerPreBoosterCardBehavior from 'State/Card/CardBehavior/JokerPreBoosterCardBehavior';
import KeyCardBehavior from 'State/Card/CardBehavior/KeyCardBehavior';
import LockCardBehavior from 'State/Card/CardBehavior/LockCardBehavior';
import PlinkoCardBehavior from 'State/Card/CardBehavior/PlinkoCardBehavior';
import PlusThreeCardBehavior from 'State/Card/CardBehavior/PlusThreeCardBehavior';
import RockCardBehavior from 'State/Card/CardBehavior/RockCardBehavior';
import ScissorCardBehavior from 'State/Card/CardBehavior/ScissorsCardBehavior';
import TornadoCardBehavior from 'State/Card/CardBehavior/TornadoCardBehavior';
import ValueCardBehavior from 'State/Card/CardBehavior/ValueCardBehavior';
import ZapCardBehavior from 'State/Card/CardBehavior/ZapCardBehavior';
import BaseCardHandler from 'System/Card/Handler/BaseCardHandler';
import BoomCardHandler from 'System/Card/Handler/BoomCardHandler';
import CanisterPreBoosterCardHandler from 'System/Card/Handler/CanisterPreBoosterCardHandler';
import GoldCardHandler from 'System/Card/Handler/GoldCardHandler';
import PlusThreeCardHandler from 'System/Card/Handler/PlusThreeCardHandler';
import RockCardHandler from 'System/Card/Handler/RockCardHandler';
import ValueCardHandler from 'System/Card/Handler/ValueCardHandler';
import BaseCard from './BaseCard';
import BoomCard from './BoomCard';
import CanisterPreBoosterCard from './CanisterPreBoosterCard';
import { CardType } from './CardType';
import GoldCard from './GoldCard';
import JokerCard from './JokerCard';
import JokerPreBoosterCard from './JokerPreBoosterCard';
import KeyCard from './KeyCard';
import LockCard from './LockCard';
import PlusThreeCard from './PlusThreeCard';
import RockCard from './RockCard';
import ScissorCard from './ScissorsCard';
import TornadoCard from './TornadoCard';
import ValueCard from './ValueCard';
import ZapCard from './ZapCard';
import PlinkoCard from './PlinkoCard';
import PlinkoCardHandler from 'System/Card/Handler/PlinkoCardHandler';

type tCardType = {
    [cardType in CardType]: {
        prototype: typeof BaseCard;
        handler: typeof BaseCardHandler;
        behavior: typeof BaseCardBehavior;
    };
};

export const CardTypeMap: tCardType = {
    [CardType.value]: {
        prototype: ValueCard,
        handler: ValueCardHandler,
        behavior: ValueCardBehavior,
    },
    [CardType.boom]: {
        prototype: BoomCard,
        handler: BoomCardHandler,
        behavior: BoomCardBehavior,
    },
    [CardType.zap]: {
        prototype: ZapCard,
        handler: BaseCardHandler,
        behavior: ZapCardBehavior,
    },
    [CardType.lock]: {
        prototype: LockCard,
        handler: BaseCardHandler,
        behavior: LockCardBehavior,
    },
    [CardType.key]: {
        prototype: KeyCard,
        handler: BaseCardHandler,
        behavior: KeyCardBehavior,
    },
    [CardType.plus_three]: {
        prototype: PlusThreeCard,
        handler: PlusThreeCardHandler,
        behavior: PlusThreeCardBehavior,
    },
    [CardType.rock]: {
        prototype: RockCard,
        handler: RockCardHandler,
        behavior: RockCardBehavior,
    },
    [CardType.scissors]: {
        prototype: ScissorCard,
        handler: BaseCardHandler,
        behavior: ScissorCardBehavior,
    },
    [CardType.tornado]: {
        prototype: TornadoCard,
        handler: BaseCardHandler,
        behavior: TornadoCardBehavior,
    },
    [CardType.joker]: {
        prototype: JokerCard,
        handler: BaseCardHandler,
        behavior: JokerCardBehavior,
    },
    [CardType.gold]: {
        prototype: GoldCard,
        handler: GoldCardHandler,
        behavior: GoldCardBehavior,
    },
    [CardType.canister_pre_booster]: {
        prototype: CanisterPreBoosterCard,
        handler: CanisterPreBoosterCardHandler,
        behavior: CanisterPreBoosterCardBehavior,
    },
    [CardType.joker_pre_booster]: {
        prototype: JokerPreBoosterCard,
        handler: BaseCardHandler,
        behavior: JokerPreBoosterCardBehavior,
    },
    [CardType.plinko]: {
        prototype: PlinkoCard,
        handler: PlinkoCardHandler,
        behavior: PlinkoCardBehavior,
    },
};
